// Helper pro formátování čísel v české lokalizaci (s mezerami jako tisícovými oddělovači).
// Vždy zaokrouhleno na celá čísla (žádné desetinné místa).
export const fmt = (n) =>
  typeof n === "number" ? Math.round(n).toLocaleString("cs-CZ") : n;

// Formát měny
export const fmtKc = (n) => (typeof n === "number" ? `${fmt(n)} Kč` : n);

// Jednotný formát data napříč celou appkou: D.M.YY (např. 6.7.26).
// POUZE pro ZOBRAZENÍ. Nikdy nepoužívat pro hodnoty, co jdou do API/PG/Sheet/porovnání.
// Přijímá ISO string ("2026-07-06" i s časem), Date, timestamp (ms) i null/prázdno.
// Neplatný/prázdný vstup → "" (u stringu vrátí původní hodnotu, ať se neztratí info).
export const formatDate = (input) => {
  if (input === null || input === undefined || input === "") return "";
  let d;
  if (input instanceof Date) {
    d = input;
  } else if (typeof input === "number") {
    d = new Date(input);
  } else {
    const s = String(input).trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); // ISO → lokální datum (bez TZ posunu)
    d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  }
  if (!d || isNaN(d.getTime())) return typeof input === "string" ? input : "";
  return `${d.getDate()}.${d.getMonth() + 1}.${String(d.getFullYear()).slice(-2)}`;
};

// Datum + čas: "D.M.YY H:MM" (např. 6.7.26 9:05). Jen pro zobrazení.
export const formatDateTime = (input) => {
  if (input === null || input === undefined || input === "") return "";
  const d = input instanceof Date ? input : (typeof input === "number" ? new Date(input) : new Date(String(input)));
  if (!d || isNaN(d.getTime())) return typeof input === "string" ? input : "";
  const datePart = `${d.getDate()}.${d.getMonth() + 1}.${String(d.getFullYear()).slice(-2)}`;
  return `${datePart} ${d.getHours()}:${String(d.getMinutes()).padStart(2, "0")}`;
};

// Zkrácený formát (např. 1.2M, 500k)
export const fmtShort = (n) => {
  if (typeof n !== "number") return n;
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(0)}k`;
  return `${n}`;
};

// Zkrácený název balíčku pro místa, kde je málo místa (karta klienta na
// telefonu, řádek s údaji). 5.9.2026, fáze 4b: mění se JEN zobrazení, uložená
// hodnota zůstává celá, takže filtry, export, Notion i automatizace pracují
// dál s původním textem.
//
//   "Permanentka: 10 osobních tréninků" → "Permanentka"
//   "Koučink FLEXIBLE 2T"               → "Flexible 2T"
//   "Koučink GOLD 3T"                   → "Gold 3T"
//   "Výživový koučink"                  → "Výživový koučink" (beze změny)
export function balicekKratce(nazev) {
  const cely = String(nazev || "").trim();
  if (!cely) return "";
  const bezDvojtecky = cely.split(":")[0].trim();
  const bezKoucinku = bezDvojtecky.replace(/^kou[čc]ink\s+/i, "").trim() || bezDvojtecky;
  // VERZÁLKY na běžné písmo, ale 1T, 2T a 3T zůstávají (je to údaj, ne křik).
  return bezKoucinku
    .split(/\s+/)
    .map((slovo) => (/^\p{Lu}{3,}$/u.test(slovo) ? slovo[0] + slovo.slice(1).toLowerCase() : slovo))
    .join(" ");
}

// Počet klientů se správným tvarem slova: 1 klient, 2 až 4 klienti, jinak klientů.
export function pocetKlientu(n) {
  const x = Number(n) || 0;
  if (x === 1) return "1 klient";
  if (x >= 2 && x <= 4) return `${x} klienti`;
  return `${fmt(x)} klientů`;
}
